type CurrentCtx = { open(): boolean }

function provideValue(ctx: None | { curr: CurrentCtx; parent(): None | ReturnType<typeof provideValue> }) {
  let _key: undefined | string
  function key() {
    _key ||= generateId()
    return _key
  }

  const data = shallowReactive<{ active: Record<string, boolean> }>({ active: {} })

  function childrenOpen() {
    return Object.values(data.active).some((i) => i)
  }

  const childrenActive = ctx?.parent?.()?.parent?.childrenActive
  if (ctx && childrenActive) {
    watch(
      () => ctx.curr.open(),
      (opened) => {
        if (helpers.isDef(opened)) childrenActive(key(), opened)
      },
      { immediate: true },
    )
    onScopeDispose(() => childrenActive(key(), false))
  }

  return {
    public: {
      childrenOpen() {
        return childrenOpen()
      },
    },
    parent: {
      childrenActive(key: string, state: boolean) {
        data.active = { ...data.active, [key]: state }
      },
    },
  }
}

const uiPreviewKey: InjectionKey<ReturnType<typeof provideValue>> = Symbol('useUiPreview4')

export function useUiPreview4(curr: CurrentCtx): { childrenOpen(): boolean } {
  const parent = inject(uiPreviewKey, () => undefined, true)
  const storage = provideValue({ curr, parent: () => parent })
  provide(uiPreviewKey, storage)
  return storage.public
}
